import React from "react";
import { Minus, Plus } from "lucide-react";
import { DENOMS } from "@/lib/constants";
import { money } from "@/lib/format";

export default function CashCounter({ value, onChange }) {
  const set = (key, n) => {
    onChange({ ...value, [key]: Math.max(0, Number(n) || 0) });
  };

  const total = DENOMS.reduce((sum, d) => sum + (Number(value[d.key]) || 0) * d.value, 0);

  return (
    <div data-testid="cash-counter" className="space-y-3">
      {DENOMS.map((d) => {
        const count = Number(value[d.key]) || 0;
        const lineTotal = count * d.value;
        return (
          <div
            key={d.key}
            data-testid={`denom-row-${d.key}`}
            className="flex items-center gap-3 bg-white rounded-xl border border-[#E8E4DA] p-3"
          >
            <div className="flex-1 min-w-0">
              <div className="text-[#0D311E] font-medium" style={{ fontFamily: "'Fraunces', serif" }}>
                {d.label}
              </div>
              <div className="text-xs text-[#5C7566]">{money(lineTotal)}</div>
            </div>
            <button
              data-testid={`denom-dec-${d.key}`}
              onClick={() => set(d.key, count - 1)}
              className="h-10 w-10 rounded-full border border-[#E8E4DA] bg-[#F5F2EA] flex items-center justify-center active:scale-95"
              aria-label={`Decrease ${d.label}`}
            >
              <Minus size={16} className="text-[#2B533E]" />
            </button>
            <input
              data-testid={`denom-input-${d.key}`}
              value={count}
              onChange={(e) => set(d.key, e.target.value.replace(/[^0-9]/g, ""))}
              inputMode="numeric"
              className="w-14 text-center text-xl text-[#0D311E] tabular-nums bg-transparent outline-none border-b-2 border-[#E8E4DA] focus:border-[#1A5D3A] py-1"
              style={{ fontFamily: "'Fraunces', serif" }}
            />
            <button
              data-testid={`denom-inc-${d.key}`}
              onClick={() => set(d.key, count + 1)}
              className="h-10 w-10 rounded-full bg-[#1A5D3A] text-white flex items-center justify-center active:scale-95 shadow-sm"
              aria-label={`Increase ${d.label}`}
            >
              <Plus size={16} />
            </button>
          </div>
        );
      })}
      <div
        data-testid="cash-counter-total"
        className="mt-4 bg-[#0D311E] text-[#FDFBF7] rounded-xl p-4 flex items-center justify-between"
      >
        <span className="text-sm tracking-[0.18em] uppercase">Cash counted</span>
        <span className="text-2xl tabular-nums" style={{ fontFamily: "'Fraunces', serif" }}>
          {money(total)}
        </span>
      </div>
    </div>
  );
}
